import _toConsumableArray from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as t } from "../../../chunks/tslib.es6.js";
import e from "../../../core/Accessor.js";
import { property as o } from "../../../core/accessorSupport/decorators/property.js";
import "../../../core/arrayUtils.js";
import "../../../core/has.js";
import "../../../core/accessorSupport/ensureType.js";
import { subclass as i } from "../../../core/accessorSupport/decorators/subclass.js";
import r from "../../../popup/FieldInfo.js";
import a from "../../../popup/content/support/ChartMediaInfoValueSeries.js";
import { substituteFieldsInLinksAndAttributes as s, fixTokens as l, substituteAttributes as n, getFixedFieldNames as d, getFixedFieldName as p, isRelatedField as u, formatValueToFieldInfo as f, getFieldInfo as m, getFieldInfoLabel as c } from "../support/featureUtils.js";
import { getRelatedFieldInfo as h } from "../support/relatedFeatureUtils.js";

var y = /*#__PURE__*/function (_e) {
  _inherits(y, _e);

  var _super = _createSuper(y);

  function y(t) {
    var _this;

    _classCallCheck(this, y);

    _this = _super.call(this, t), _this.activeMediaInfoIndex = 0, _this.attributes = null, _this.description = null, _this.fieldInfoMap = null, _this.formattedAttributes = null, _this.expressionAttributes = null, _this.layer = null, _this.mediaInfos = null, _this.popupTemplate = null, _this.relatedInfos = null, _this.title = null;
    return _this;
  }

  _createClass(y, [{
    key: "activeMediaInfo",
    get: function get() {
      return this.formattedMediaInfos[this.activeMediaInfoIndex] || null;
    }
  }, {
    key: "formattedMediaInfos",
    get: function get() {
      return this._formatMediaInfos() || [];
    }
  }, {
    key: "formattedMediaInfoCount",
    get: function get() {
      return this.formattedMediaInfos.length;
    }
  }, {
    key: "setActiveMedia",
    value: function setActiveMedia(t) {
      this._setContentElementMedia(t);
    }
  }, {
    key: "next",
    value: function next() {
      this._pageContentElementMedia(1);
    }
  }, {
    key: "previous",
    value: function previous() {
      this._pageContentElementMedia(-1);
    }
  }, {
    key: "_setContentElementMedia",
    value: function _setContentElementMedia(t) {
      var e = this.formattedMediaInfoCount,
          o = (t + e) % e;
      this.activeMediaInfoIndex = o;
    }
  }, {
    key: "_pageContentElementMedia",
    value: function _pageContentElementMedia(t) {
      var e = this.activeMediaInfoIndex,
          o = e + t;

      this._setContentElementMedia(o);
    }
  }, {
    key: "_formatMediaInfos",
    value: function _formatMediaInfos() {
      var _this2 = this;

      var t = this.attributes,
          e = this.mediaInfos,
          o = this.formattedAttributes,
          i = this.expressionAttributes,
          r = this.fieldInfoMap,
          a = this.layer;
      return null == e ? void 0 : e.map(function (e) {
        var l = null == e ? void 0 : e.clone();
        if (!l) return null;

        if (l.title = s({
          attributes: t,
          fieldInfoMap: r,
          globalAttributes: o,
          expressionAttributes: i,
          layer: a,
          text: l.title
        }), l.caption = s({
          attributes: t,
          fieldInfoMap: r,
          globalAttributes: o,
          expressionAttributes: i,
          layer: a,
          text: l.caption
        }), l.altText = s({
          attributes: t,
          fieldInfoMap: r,
          globalAttributes: o,
          expressionAttributes: i,
          layer: a,
          text: l.altText
        }), "image" === l.type) {
          var _t = l.value;
          return _this2._setImageValue({
            value: _t,
            formattedAttributes: o,
            layer: a
          }), l.value.sourceURL ? l : void 0;
        }

        if ("pie-chart" === l.type || "line-chart" === l.type || "column-chart" === l.type || "bar-chart" === l.type) {
          var _e2 = l.value;
          return _this2._setChartValue({
            value: _e2,
            chartType: l.type,
            attributes: t,
            formattedAttributes: o,
            layer: a
          }), l;
        }

        return null;
      }).filter(Boolean);
    }
  }, {
    key: "_setImageValue",
    value: function _setImageValue(t) {
      var e = this.fieldInfoMap,
          o = t.value,
          i = t.formattedAttributes,
          r = t.layer,
          a = o.linkURL,
          s = o.sourceURL;

      if (s) {
        var _t2 = l(s, r);

        o.sourceURL = n({
          formattedAttributes: i,
          template: _t2,
          fieldInfoMap: e
        });
      }

      if (a) {
        var _t3 = l(a, r);

        o.linkURL = n({
          formattedAttributes: i,
          template: _t3,
          fieldInfoMap: e
        });
      }
    }
  }, {
    key: "_setChartValue",
    value: function _setChartValue(t) {
      var _this3 = this;

      var e = t.value,
          o = t.attributes,
          i = t.formattedAttributes,
          r = t.chartType,
          a = t.layer,
          s = this.popupTemplate,
          l = this.relatedInfos,
          n = e.fields,
          f = e.normalizeField;
      e.fields = d(n, a), f && (e.normalizeField = p(f, a));
      if (!n.some(function (t) {
        return !!(null != i[t] || u(t) && l.size);
      })) return;
      var m = null == s ? void 0 : s.fieldInfos;
      n.forEach(function (t) {
        if (u(t)) return void (e.series = [].concat(_toConsumableArray(e.series), _toConsumableArray(_this3._getRelatedChartInfos({
          fieldInfos: m,
          fieldName: t,
          formattedAttributes: i,
          chartType: r,
          value: e
        }))));

        var a = _this3._getChartOption({
          value: e,
          attributes: o,
          chartType: r,
          formattedAttributes: i,
          fieldName: t,
          fieldInfos: m
        });

        e.series.push(a);
      });
    }
  }, {
    key: "_getRelatedChartInfos",
    value: function _getRelatedChartInfos(t) {
      var _this4 = this;

      var e;
      var o = t.fieldInfos,
          i = t.fieldName,
          r = t.formattedAttributes,
          a = t.chartType,
          s = t.value,
          l = [],
          n = h(i),
          d = n.layerId,
          p = n.fieldName,
          u = null == (e = this.relatedInfos) ? void 0 : e.get(d.toString());
      if (!u) return l;
      var f = u.relatedFeatures,
          m = u.relation;
      if (!m || !f) return l;
      var c = m.cardinality;
      f.forEach(function (t) {
        var e = t.attributes;
        e && Object.keys(e).forEach(function (t) {
          t === p && l.push(_this4._getChartOption({
            value: s,
            attributes: e,
            formattedAttributes: r,
            fieldName: i,
            chartType: a,
            relatedFieldName: t,
            fieldInfos: o
          }));
        });
      });
      return "one-to-many" === c || "many-to-many" === c ? l : [l[0]];
    }
  }, {
    key: "_getTooltip",
    value: function _getTooltip(_ref) {
      var t = _ref.label,
          e = _ref.value,
          o = _ref.chartType;
      return "pie-chart" === o ? t : "".concat(t, ": ").concat(e);
    }
  }, {
    key: "_getChartOption",
    value: function _getChartOption(t) {
      var e;

      var o = t.value,
          i = t.attributes,
          s = t.formattedAttributes,
          l = t.fieldName,
          n = t.relatedFieldName,
          d = t.fieldInfos,
          _y = t.chartType,
          I = this.layer,
          v = o.normalizeField,
          b = o.tooltipField,
          M = v ? u(v) ? i[h(v).fieldName] : i[v] : null,
          g = n && void 0 !== i[n] ? i[n] : void 0 !== i[l] ? i[l] : s[l],
          A = void 0 === g ? null : g && M ? g / M : g,
          _ = new a({
        value: A
      });

      if (u(l)) {
        var _t4 = h(l),
            _e3 = h(b),
            _o = _e3 ? _e3.fieldName : null,
            _r = f(A, {
          fieldInfos: d,
          fieldName: n,
          layer: I,
          preventPlacesFormatting: !!M
        }),
            _a = _t4 ? _t4.label || _t4.fieldName : n,
            _s = _o && void 0 !== i[_o] ? i[_o] : _a;

        return _.tooltip = this._getTooltip({
          label: _s,
          value: _r,
          chartType: _y
        }), _;
      }

      var x = m(d, l),
          T = p(l, I),
          C = b && void 0 !== s[b] ? s[b] : c(x || new r({
        fieldName: T
      }), null == (e = this.popupTemplate) ? void 0 : e.expressionInfos),
          F = s[T];
      return _.tooltip = this._getTooltip({
        label: C,
        value: F,
        chartType: _y
      }), _;
    }
  }]);

  return y;
}(e);

t([o()], y.prototype, "activeMediaInfoIndex", void 0), t([o({
  readOnly: !0
})], y.prototype, "activeMediaInfo", null), t([o()], y.prototype, "attributes", void 0), t([o()], y.prototype, "description", void 0), t([o()], y.prototype, "fieldInfoMap", void 0), t([o()], y.prototype, "formattedAttributes", void 0), t([o()], y.prototype, "expressionAttributes", void 0), t([o({
  readOnly: !0
})], y.prototype, "formattedMediaInfos", null), t([o()], y.prototype, "layer", void 0), t([o({
  readOnly: !0
})], y.prototype, "formattedMediaInfoCount", null), t([o()], y.prototype, "mediaInfos", void 0), t([o()], y.prototype, "popupTemplate", void 0), t([o()], y.prototype, "relatedInfos", void 0), t([o()], y.prototype, "title", void 0), y = t([i("esri.widgets.Feature.FeatureMedia.FeatureMediaViewModel")], y);
var I = y;
export { I as default };